export const EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER

if (!EXPRESS_SERVER) {
  throw Error("You must define the REACT_APP_EXPRESS_SERVER url in the env vars")
}
